import { Content } from "@prismicio/client";
import {
  PrismicImage,
  PrismicRichText,
  SliceComponentProps,
} from "@prismicio/react";
import { TitlePage } from "@components/commun";
import { Text } from "@components/ui";
import style from "./FiveSuccessKeys.module.scss";

/**
 * Props for `FiveSuccessKeys`.
 */
export type FiveSuccessKeysProps =
  SliceComponentProps<Content.FiveSuccessKeysSlice>;

/**
 * Component for "FiveSuccessKeys" Slices.
 */
const FiveSuccessKeys = ({ slice }: FiveSuccessKeysProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={style.wrapper}
    >
      <TitlePage className={style.title}>
        <PrismicRichText field={slice.primary.title} />
      </TitlePage>
      <Text variant="span" className={style.subtitle}>
        <PrismicRichText field={slice.primary.subtitle} />
      </Text>
      <div className="lk-wrap large">
        <div className={style.keysWrap}>
          <div className={style.img}>
            <PrismicImage field={slice.primary.image} />
          </div>
          <div className={style.items}>
            {slice.items.map((item, index) => (
              <div key={index} className={style.item} data-index={index + 1}>
                <PrismicRichText field={item.key} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FiveSuccessKeys;
